export enum QuestionAnswerValueType {
  TermsAndConditions = 'Terms',
  FAQ = 'FAQ',
  PrivacyPolicy = 'PrivacyPolicy',
}
